// api/index.js用于导入apiList中的所有接口，此时api/index模块导出为一个object（参数为apiList中每个文件名，value值为对应的函数）
const modulesFiles = require.context('./apiList', true, /\.js$/)

export default modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default || value
  return modules
}, {})
